import { loadStripe, Stripe } from '@stripe/stripe-js';
import { Codeowners } from '../../consts/codeowners';
import { captureException } from '../../utils/exception';

let stripePromise: Stripe | PromiseLike<Stripe | null> | null = null;
let retryCount = 0;

const initializeStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(window.STRIPE_PUBLISHABLE_KEY, { locale: 'en' }).catch((error) => {
      if (retryCount < 3) {
        retryCount += 1;
        console.error(`Failed to load Stripe: ${error}`);
        console.warn(`Retrying to load Stripe: ${retryCount}`);
        initializeStripe();
      } else {
        captureException(error, Codeowners.CUSTOMER_INTAKE);
      }
    }) as PromiseLike<Stripe | null> | null;
  }
  return stripePromise;
};

export default () => initializeStripe();
